export default {"src":"/hedera/_next/static/media/sun_light.4246f91e.svg","height":16,"width":16};